<template>
  <footer class="footer-container">
  <!-- 友情链接部分 -->
    <div class="links-section">
      <div class="links-container">
        <MenuBox :is-type="'top'" :list="menulist" />
      </div>
    </div>

  <!-- 联系信息部分 -->
  <div class="contact-section">
      <div class="contact-info">
        <div class="info-item">
          <span>技术支持：(0531) 61303517</span>
        </div>
        <div class="info-item">
          <span>邮箱：smscbgs@163.com</span>
        </div>
        <div class="info-item">
          <span>地址：济南市历城区华悦路汉峪金谷A6-2栋</span>
        </div>
        <div class="info-item">
          <span>工信部链接：<a href="https://beian.miit.gov.cn/" target="_blank">https://beian.miit.gov.cn/</a></span>
        </div>
      </div>
    </div>
    <!-- 版权信息 -->
    <div class="copyright-section">
      <p>山东省神经科学学会、山东省阿尔茨海默病防治协会版权所有 © 2024 sdssjkxxh.com All Rights Reserved</p>
      <p>备案证号：鲁ICP备2024114083号</p>
    </div>
  </footer>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import MenuBox from '@/components/boxChange/boxTop.vue';
import { friendlyLink, brotherLink } from '@/pubilc/data';

const menulist = ref([
  {
    value: 1,
    label: '政府网站',
    children: [ ...friendlyLink ]
  },
  {
    value: 2,
    label: '兄弟学（协）会',
    children: [ ...brotherLink ]
  },
])

</script>

<style lang="scss" scoped>
.footer-container {
  font-family: 'Microsoft YaHei', sans-serif;
  width: 100%;
  background: linear-gradient(to bottom, #f8fbfe, #e6f2ff);
  box-shadow: 0 -2px 10px rgba(19, 115, 192, 0.1);
}
// 政府网站，兄弟学会
.links-section {
  padding: 1rem 0;
  background-color: #f0f7ff;
  border-bottom: 1px solid #d1e3ff;
  
  .links-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
    display: grid;
    grid-template-columns: repeat(2, auto); // 两列自动宽度
    justify-content: center;               // 水平居中
    gap: 700px;                            // 设置间距为30px
    
    // 如果需要响应式调整
    @media (max-width: 768px) {
      grid-template-columns: 1fr;         // 小屏幕下单列显示
      gap: 200px;                         // 减小间距
    }
  }
}
  
  .contact-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 16%;
  background: linear-gradient(135deg, #0F61A4, #1373C0);
  color: white;
  
  .contact-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    
    .info-item {
      display: flex;
      align-items: center;
      gap: 0.8rem;
      font-size: 0.9rem;
      
      a {
        color: #a8d4ff;
        text-decoration: none;
        transition: color 0.3s;
        
        &:hover {
          color: white;
          text-decoration: underline;
        }
      }
    }
  }
}

.copyright-section {
  padding: 0.5rem 0;
  text-align: center;
  background: #125992;
  color: white;
  font-size: 0.8rem;
  
  p {
    // margin: 0.3rem 0;
    line-height: 1.5;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .links-section {
    .links-container {
      display: block;
      padding: 0 1rem;
      
      /* 调整菜单间距 */
      > * {
        margin-bottom: 15px;
      }
    }
  }
}

</style>